/*
 * @Desc: 物业管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-23 10:52:22
 */
import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/order/list",
      method: "get",
      params: query
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/order/detail",
      method: "post",
      params: query
    });
  },
   // 导出
    exportData(query) {
      return request({
        url: "/order/export",
        method: "post",
        params: query
      });
    },
    // 导出列表
    daoList(query) {
    return request({
      url: "/exportorders/list",
      method: "get",
      params: query
    });
  },
};
export default index;